import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { DonutRangeModel } from './donut-range.model';

@Component({
  selector: 'app-donut',
  templateUrl: './donut.component.html',
  styleUrls: ['./donut.component.scss']
})

export class DonutComponent implements OnChanges {
  public width;
  public height;
  public circle_transform = '';
  public cx;
  public cy;
  public text_transform: 'translate ()';

  @Input('stroke_width') stroke_width = '12';
  @Input('r') r = 90;
  @Input('values') values: Array<DonutRangeModel>;
  @Input() label;
  @Input() labelText;
  @Input() userValue;

  constructor() {}
  ngOnChanges() {
    const square = ((Number(this.r) + Number(this.stroke_width)) * 2);
    this.width =  square + 'px';
    this.height = square + 'px';
    this.cx = square / 2;
    this.cy = square / 2;
    this.circle_transform = 'translate(' + 0 + ' ' + this.cy * 2 + ') rotate(-90)';
  }
  setDonuts(amount, index) {
    let buffer = 0;
    for (let i = this.values.length - 1; i > index; i--) {
      buffer = buffer + Number(this.values[i].range);
    }
    amount = Number(amount) + buffer;
    const perimeter = 2 * 3.14 * this.r;
    const fillAmount = perimeter - perimeter * amount / 100;
    return {
      'stroke_dash_array': perimeter,
      'stroke_dash_offset': fillAmount
    };
  }
}
